const defaultHours = {
    0: {open: null, close: null},
    1: {open: null, close: null},
    2: {open: null, close: null},
    3: {open: null, close: null},
    4: {open: null, close: null},
    5: {open: null, close: null},
    6: {open: null, close: null},
};

const transformHoursArrIntoObj = (hoursArr) => {
    if (!hoursArr || !hoursArr?.length) {
        return defaultHours;
    }

    return hoursArr.reduce(
        (weekTimes, {day, open_time, close_time}) => ({
            ...weekTimes,
            [day]: {
                open: open_time,
                close: close_time,
            },
        }),
        {},
    );
};

module.exports = {
    defaultHours,
    transformHoursArrIntoObj
};